import { Capacitor, registerPlugin } from "@capacitor/core";

type VoicePermissionStatus = {
  microphone?: string;
  notifications?: string;
};

type LorenaVoicePlugin = {
  configure(options: { backendUrl: string; authToken: string }): Promise<{ configured: boolean }>;
  requestVoicePermissions(): Promise<VoicePermissionStatus>;
  startListening(): Promise<{ listening: boolean }>;
  stopListening(): Promise<{ listening: boolean }>;
};

const LorenaVoice = registerPlugin<LorenaVoicePlugin>("LorenaVoice");

export async function initializeLorenaVoice(): Promise<void> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") {
    return;
  }

  const backendUrl = process.env.VUE_APP_BACKEND_API_URL;
  const authToken = localStorage.getItem("auth_token");

  if (!backendUrl || !authToken) {
    return;
  }

  await LorenaVoice.configure({ backendUrl, authToken });
  const permissions = await LorenaVoice.requestVoicePermissions();

  if (permissions.microphone === "granted") {
    await LorenaVoice.startListening();
  }
}

export async function stopLorenaVoice(): Promise<void> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") {
    return;
  }

  await LorenaVoice.stopListening();
}
